import React from "react";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";
import { apiHandler } from "../assets/api/index.js";
import { endpoint } from "../assets/api/endpoint";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const GameInvitation = ({ onClose, filteredData }) => {
    const navigate = useNavigate();
    const { accessToken } = useSelector((state) => state.loginInfo);
    const gameId = filteredData.additionalData.gameId;

    const handleClick = async (action) => {
        try {
            const result = await apiHandler({
                url: `${endpoint.GAME_INVITATION}?action=${action}`,
                method: "POST",
                authToken: accessToken?.accessToken,
                data:{
                    gameId: gameId ,
                    transactionId:null,
                    paymentIntentId:null
                  },
            });
            if (result?.data?.message) {
                toast.success(result?.data?.message);
            } else {
                toast.error("Failed to send invitation response");
            }
        } catch (error) {
            console.error("Error processing invitation:", error);
            toast.error("An error occurred");
        }

        navigate(-1);
        onClose();
    };

    return (
        <div
            className="modal-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                className="modal-content"
                style={{
                    width: "400px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    padding: "20px",
                    textAlign: "center",
                }}
            >
                {/* Icon */}
                <div className="text-primary mb-3">
                    <div
                        className="rounded-circle d-inline-flex justify-content-center align-items-center"
                        style={{
                            width: "50px",
                            height: "50px",
                            border: "2px solid #007bff",
                            fontSize: "1.5rem",
                        }}
                    >
                        ?
                    </div>
                </div>
                <h4>Game Invitation</h4>

                {/* Buttons */}
                <div className="d-flex justify-content-center">
                    <CustomButton
                        buttonText={"Yes"}
                        className="border"
                        style={{
                            width: "70px",
                            height: "48px",
                            borderRadius: "12px",
                            background: "#006FFD",
                            color: "#FFFFFF",
                            marginRight: "15px",
                        }}
                        onClick={() => handleClick(true)}
                    />
                    <CustomButton
                        buttonText={"No"}
                        className="border"
                        style={{
                            width: "70px",
                            height: "48px",
                            borderRadius: "12px",
                            background: "#006FFD",
                            color: "#FFFFFF",
                        }}
                        onClick={() => handleClick(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default GameInvitation;
